import type { LocaleObject, Country } from '@/types/locale';

export const cmsLivePreviewLanguageMappings: { [key: string]: string } = {
  de: 'de',
  en: 'en',
  nl: 'nl',
  pl: 'pl',
  it: 'it',
  es: 'es',
  fr: 'fr',
};

export const localeList: LocaleObject[] = [
  {
    code: 'en',
    cmsFallbackLanguage: 'default',
    lang: 'en',
    alpha3: 'ENG',
  },
  {
    code: 'de',
    cmsFallbackLanguage: 'en',
    lang: 'de',
    alpha3: 'DEU',
  },
  {
    code: 'pl',
    cmsFallbackLanguage: 'en',
    lang: 'pl',
    alpha3: 'POL',
  },
  {
    code: 'nl',
    cmsFallbackLanguage: 'en',
    lang: 'nl',
    alpha3: 'NLD',
  },
  {
    code: 'it',
    cmsFallbackLanguage: 'en',
    lang: 'it',
    alpha3: 'ITA',
  },
  {
    code: 'es',
    cmsFallbackLanguage: 'en',
    lang: 'es',
    alpha3: 'ESP',
  },
  {
    code: 'fr',
    cmsFallbackLanguage: 'en',
    lang: 'fr',
    alpha3: 'FRA',
  },
];

export const COUNTRY_MAP: { [key: string]: string } = {
  29: 'DE',
  153: 'PL',
  74: 'ES',
  161: 'RO',
  103: 'IT',
  40: 'BE',
  91: 'NL',
  79: 'FR',
  160: 'CZ',
  175: 'SE',
};

export const LOCALE_MAP: { [key: string]: string } = {
  29: 'de',
  35: 'de', // austria
  176: 'de', // switzerland
  153: 'pl',
  74: 'es',
  161: 'ro',
  103: 'it',
  40: 'fr', // belgium
  91: 'nl',
  79: 'fr',
  160: 'cs',
  175: 'se',
};

export const defaultLocale: string = localeList[0].code;

export function getLocalesFromCountry(localeList: LocaleObject[], country: Country): string[] {
  const list: string[] = [].slice.call(localeList);
  country = country.toLowerCase();
  return list.reduce((locales: string[], locale: any) => {
    if (locale !== undefined && locale.code.split('-')[1] === country) {
      locales.push(locale.code);
    }
    return locales;
  }, []);
}

export function extractCountriesFromLocaleList(filteredLocaleList: LocaleObject[]): string[] {
  const countryList: string[] = [];
  filteredLocaleList.forEach((locale: LocaleObject) => {
    const country: string = getCountryFromLocale(locale);
    if (countryList.includes(country)) {
      return;
    }
    countryList.push(country);
  });
  return countryList;
}

export function getCountryFromLocale(locale: LocaleObject | undefined): string {
  return locale ? locale.code : '';
}
